import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginCard, useTheme, type SyncJobRow } from '@eb/auth-ui';
import { useAuth } from '~/contexts/AuthContext';
import { supabase } from '~/lib/supabase-browser';

// Thin adapter over the shared @eb/auth-ui LoginCard. Branding + this app's
// supabase client are the only per-app bits; the card itself is identical
// across all three EB apps. pollSyncJob lives here (not in the package) so the
// app's own cookie-based supabase client polls sync_jobs — keeping the package
// data-layer-agnostic and the protected chunk untouched.
export default function Login() {
  const { user, loading, signIn, signInWithGoogle } = useAuth();
  const { refreshAccountTheme } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate('/', { replace: true });
  }, [user, loading, navigate]);

  return (
    <LoginCard
      branding={{ title: 'EntityBox Comedy', accent: 'amber' }}
      actions={{ signIn, signInWithGoogle }}
      onAuthenticated={() => {
        // The mount-time account-theme sync ran before a session existed.
        void refreshAccountTheme();
        navigate('/', { replace: true });
      }}
      dev={{
        isDev: import.meta.env.VITE_ENV === 'dev',
        reseedEndpoint: '/.netlify/functions/reseedDevUser',
        syncEndpoint: '/.netlify/functions/syncFromProd-background',
        dbBranchLabel: (import.meta.env.VITE_DB_BRANCH as string | undefined) ?? null,
        pollSyncJob: async (since) => {
          let q = supabase
            .from('sync_jobs')
            .select('*')
            .order('started_at', { ascending: false })
            .limit(1);
          if (since) q = q.gte('started_at', since);
          const { data } = await q;
          return (data?.[0] as SyncJobRow | undefined) ?? null;
        },
      }}
    />
  );
}
